import type { SVGProps } from 'react';

const FILLED_STAR_PATH =
    'M8.00002 0C8.21811 0 8.41422 0.132774 8.49521 0.335258L10.4944 5.33333H15.4667C15.6889 5.33333 15.8878 5.47108 15.9659 5.67908C16.0441 5.88707 15.9851 6.12173 15.8179 6.26804L11.8024 9.78162L13.3146 15.3263C13.375 15.5478 13.2869 15.7831 13.0959 15.9104C12.9049 16.0378 12.6538 16.0286 12.4726 15.8877L8.00002 12.409L3.52746 15.8877C3.34625 16.0286 3.09519 16.0378 2.90418 15.9104C2.71318 15.7831 2.62508 15.5478 2.68548 15.3263L4.19768 9.78162L0.182155 6.26804C0.0149389 6.12173 -0.044048 5.88707 0.0341026 5.67908C0.112253 5.47108 0.311166 5.33333 0.533357 5.33333H5.50561L7.50484 0.335258C7.58583 0.132774 7.78194 0 8.00002 0Z';

export const StarFilledIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
        {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d={FILLED_STAR_PATH} />
    </svg>
);
